// import utility function
import {
  calculateNumeratorDenominatorPayment,
  calculatePrincipalRateTerm,
  deformatCurrency,
  formatCurrencyString,
} from '../util';

/**
 *
 * Calculate max total amount of loan and max monthly loan payment based on various inputs
 * Formula for this was adapated from the old PHP calculators OTHL sites used to use
 *
 * Parameters are all values from inputs
 *
 * @param {string} annualInterestRate
 * @param {string} termOfTheLoan
 * @param {string} annualRealEstateTaxes
 * @param {string} annualHomeownersInsurance
 * @param {string} grossAnnualIncome
 * @param {string} monthlyDebtObligations
 * @return {String[]} [maximum monthly loan payment, maximum total loan amount]
 */
function calculateAffordability(
  annualInterestRate,
  termOfTheLoan,
  annualRealEstateTaxes,
  annualHomeownersInsurance,
  grossAnnualIncome,
  monthlyDebtObligations
) {
  // if empty string sent do this, otherwise deformatCurrency will geek
  if (!annualRealEstateTaxes) annualRealEstateTaxes = '$0';
  if (!annualHomeownersInsurance) annualHomeownersInsurance = '$0';
  if (!monthlyDebtObligations) monthlyDebtObligations = '$0';

  // remove extraneous characters from strings
  const annualIncome = deformatCurrency(grossAnnualIncome);
  const annualInsurance = deformatCurrency(annualHomeownersInsurance);
  // these are parsed into numbers directly
  const annualTax = parseInt(deformatCurrency(annualRealEstateTaxes));
  const monthlyDebt = parseInt(deformatCurrency(monthlyDebtObligations));

  const maximumMonthly = monthlyDebtObligations
    ? // annualIncome and annualInsurance are automatically coerced into numbers here
      (annualIncome * 0.44 - annualTax - annualInsurance) / 12 - monthlyDebt
    : (annualIncome * 0.44 - annualTax - annualInsurance) / 12;

  const [, rate, term] = calculatePrincipalRateTerm({
    annualInterestRate,
    termOfTheLoan,
  });

  const [numerator, denominator] = calculateNumeratorDenominatorPayment({
    rate,
    term,
  });

  const maximumAmount = formatCurrencyString(
    maximumMonthly / (numerator / denominator)
  );

  // maximumMonthly isn't formatted until now as the number is used in maximumAmount calculation
  return [formatCurrencyString(maximumMonthly), maximumAmount];
}

export default calculateAffordability;



// WEBPACK FOOTER //
// ./scripts/svelte/calculators/affordabilityCalculator/calculateAffordability.js